/**
 * This component was generated by the icon-component-creation.mjs script. PLEASE DO NOT EDIT THIS FILE DIRECTLY.
 */

import * as React from 'react';
import { createSvgIcon } from '@mui/material';

export const DesignLogoIcon = createSvgIcon(
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 166 166"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    style={{ fillRule: 'evenodd', clipRule: 'evenodd', strokeLinejoin: 'round', strokeMiterlimit: '2' }}
  >
    <g transform="matrix(1,0,0,1,-1038.75,-961.802)">
      <g transform="matrix(0.742191,0,0,0.742191,886.437,-933.206)">
        <g transform="matrix(0.682377,0,0,0.682377,-6.48265,2501.7)">
          <path
            d="M636.644,134.398L636.644,343.126C636.644,375.596 610.282,401.958 577.812,401.958L369.084,401.958C336.614,401.958 310.252,375.596 310.252,343.126L310.252,134.398C310.252,101.928 336.614,75.566 369.084,75.566L577.812,75.566C610.282,75.566 636.644,101.928 636.644,134.398Z"
            style={{ fill: 'rgb(44,94,75)' }}
          />
          <clipPath id="_clip1">
            <path d="M636.644,134.398L636.644,343.126C636.644,375.596 610.282,401.958 577.812,401.958L369.084,401.958C336.614,401.958 310.252,375.596 310.252,343.126L310.252,134.398C310.252,101.928 336.614,75.566 369.084,75.566L577.812,75.566C610.282,75.566 636.644,101.928 636.644,134.398Z" />
          </clipPath>
          <g clipPath="url(#_clip1)">
            <rect x="310.252" y="75.566" width="326.392" height="326.392" style={{ fill: 'url(#_Linear2)' }} />
            <g transform="matrix(1.30848e-16,0.463035,-1.05528,-5.01187e-17,1257.61,-637.992)">
              <rect x="2081.46" y="733.995" width="231.834" height="18.182" style={{ fill: 'rgb(77,147,120)' }} />
            </g>
            <g transform="matrix(1.23981e-16,0.438795,-1.05528,-3.18461e-17,1315.33,-569.008)">
              <rect x="2081.46" y="733.995" width="231.834" height="18.182" style={{ fill: 'rgb(77,147,120)' }} />
            </g>
            <g transform="matrix(-5.67961e-17,0.438795,1.05528,3.37535e-18,-368.432,-569.008)">
              <rect x="2081.46" y="733.995" width="231.834" height="18.182" style={{ fill: 'rgb(77,147,120)' }} />
            </g>
            <g transform="matrix(1.29158e-16,0.457072,-1.05528,-4.56238e-17,1373.05,-625.581)">
              <rect x="2081.46" y="733.995" width="231.834" height="18.182" style={{ fill: 'rgb(77,147,120)' }} />
            </g>
            <g transform="matrix(-5.67961e-17,0.438795,1.05528,3.37535e-18,-426.15,-583.302)">
              <rect x="2081.46" y="733.995" width="231.834" height="18.182" style={{ fill: 'rgb(77,147,120)' }} />
            </g>
            <g transform="matrix(1.25487,0.069475,0.069475,1.25487,-2314.43,-686.772)">
              <path
                d="M2182.22,519.496L2195.08,506.64L2340.41,651.978L2327.56,664.834L2182.22,519.496Z"
                style={{ fill: 'rgb(77,147,120)' }}
              />
            </g>
            <g transform="matrix(-1.30214,0.116746,-0.116746,1.30214,3402.78,-828.717)">
              <path
                d="M2203.8,515.367L2190.95,528.224L2327.56,664.834L2340.41,651.978L2203.8,515.367Z"
                style={{ fill: 'rgb(77,147,120)' }}
              />
            </g>
            <g transform="matrix(0.994678,0,0,0.994678,473.448,291.481)">
              <path
                d="M-146.059,15.022L0,-131.212L145.708,14.889L-146.059,15.022ZM-96.694,-3.216L-28.141,-3.247L-62.376,-37.574L-96.694,-3.216ZM9.645,-90.474L9.679,-15.259L47.342,-52.821L9.645,-90.474ZM28.494,-3.216L97.046,-3.247L62.811,-37.574L28.494,-3.216ZM-9.645,-90.474L-47.342,-52.821L-9.679,-15.259L-9.645,-90.474Z"
                style={{ fill: 'white' }}
              />
            </g>
          </g>
        </g>
      </g>
    </g>
    <defs>
      <linearGradient
        id="_Linear2"
        x1="0"
        y1="0"
        x2="1"
        y2="0"
        gradientUnits="userSpaceOnUse"
        gradientTransform="matrix(2.16861e-12,322.587,-322.587,2.16861e-12,473.448,-83.8248)"
      >
        <stop offset="0" style={{ stopColor: 'rgb(77,147,120)', stopOpacity: '1' }} />
        <stop offset="1" style={{ stopColor: 'rgb(77,147,120)', stopOpacity: '0' }} />
      </linearGradient>
    </defs>
  </svg>,
  'DesignLogoIcon',
);
